module.exports = __webpack_public_path__ + "img/gary-pro.44563b60.jpg";